import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMutation } from "react-query";
import { useLocation } from "react-router-dom";
import PopupModel from "../popupmodel/PopupModel";

const NewExecutive = () => {
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const { state } = useLocation();

  let companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
  console.log("company", companyDetails);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/executives`,
          postData
        );

        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add executive",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to add quotation. Please try again.");
      },
    }
  );
  //

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/executives/${state?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating quotation:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add executive",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the executive. Please try again.");
      },
    }
  );

  useEffect(() => {
    if (state) {
      setValue("executiveName", state?.executiveName || "");
      setValue("phoneNumber", state?.phoneNumber || "");
      setValue("alternativePhNo", state?.alternativePhNo || "");
      setValue("email", state?.email || "");
      setValue("address", state?.address || "");
      setValue("city", state?.city || "");
      setValue("pincode", state?.pincode || "");
      setValue("panNumber", state?.panNumber || "");
      setValue("aadharNo", state?.aadharNo || "");
      setValue("status", state?.status || "");
      setValue("role", state?.role || "");
      setValue("vehicleNumber", state?.vehicleNumber || "");
      setValue("password", state?.password || "");
      setValue("confirmPassword", state?.confirmPassword || "");
    }
  }, [state, setValue]);

  const onSubmit = (data) => {
    if (data?.password !== data?.confirmPassword) {
      alert("Password and Confirm Password must match.");
      return;
    }

    let formData = {
      executiveName: data?.executiveName || null,
      phoneNumber: data?.phoneNumber || null,
      alternativePhNo: data?.alternativePhNo || null,
      email: data?.email || null,
      address: data?.address || null,
      city: data?.city || null,
      pincode: data?.pincode || null,
      panNumber: data?.panNumber || null,
      aadharNo: data?.aadharNo || null,
      status: data?.status || null,
      role: data?.role || null,
      vehicleNumber: data?.vehicleNumber || null,
      password: data?.password || null,
      confirmPassword: data?.confirmPassword || null,
      shopName: companyDetails?.shopName || null,
    };

    if (state?.id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };
  return (
    <>
      <div className="form_main_block">
        <div className="form_sub_block">
          <form className="p-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="row px-3">
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">
                  Executive Name<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="executiveName"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Executive name is required" }}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <div>
                      <input
                        {...field}
                        type="text"
                        placeholder="Name"
                        aria-invalid={invalid}
                        className={`executive_input_field ${
                          invalid ? "is-invalid" : ""
                        }`}
                      />
                      {error && (
                        <div
                          className="invalid-feedback"
                          style={{ fontSize: "12px" }}
                        >
                          {error?.message}
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">City</label>
                <Controller
                  name="city"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="City"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">
                  Phone Number<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="phoneNumber"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Phone number is required" }}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <div>
                      <input
                        {...field}
                        type="tel"
                        placeholder="Phone Number"
                        aria-invalid={invalid}
                        className={`executive_input_field ${
                          invalid ? "is-invalid" : ""
                        }`}
                      />
                      {error && (
                        <div
                          className="invalid-feedback"
                          style={{ fontSize: "12px" }}
                        >
                          {error?.message}
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Pincode</label>
                <Controller
                  name="pincode"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="number"
                      placeholder="Pincode"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Alter Phone Number</label>
                <Controller
                  name="alternativePhNo"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="tel"
                      placeholder="Alter Phone Number"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Pan Number</label>
                <Controller
                  name="panNumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="PAN Number"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">E-Mail ID</label>
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="email"
                      placeholder="Email ID"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Aadhar Number</label>
                <Controller
                  name="aadharNo"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="AADHAR Number"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Address</label>
                <Controller
                  name="address"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Addresss"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>
              {/* <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Aadhar Upload</label>
                <Controller
                  name="aadharCard"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <div className="mb-3">
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        className="executive_input_field"
                      />
                    </div>
                  )}
                />
              </div> */}
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Vehicle No</label>
                <Controller
                  name="vehicleNumber"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="Vehicle No"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">
                  Role<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="role"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Role is required" }}
                  render={({ field, fieldState: { error, invalid } }) => (
                    <div>
                      <select
                        {...field}
                        aria-invalid={invalid}
                        className={`executive_input_field ${
                          invalid ? "is-invalid" : ""
                        }`}
                      >
                        <option value="">Select Role</option>
                        <option value="Sales">Sales</option>
                        <option value="Others">Others</option>
                      </select>
                      {error && (
                        <div className="invalid-feedback">{error?.message}</div>
                      )}
                    </div>
                  )}
                />
              </div>
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Status</label>
                <Controller
                  name="status"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select {...field} className="executive_input_field">
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  )}
                />
              </div>
            </div>
            <div className="row px-3">
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Password</label>
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="password"
                      placeholder="********"
                      className="executive_input_field"
                      required
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-6 d-flex flex-column gap-2 mb-2">
                <label className="executive_label">Confirm Password</label>
                <Controller
                  name="confirmPassword"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="password"
                      placeholder="********"
                      className="executive_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3 my-2">
              <div className="col-12 col-md-6">
                <button className="form_submit_btn">
                  {postLoading || putLoading ? (
                    <>
                      <i class="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <PopupModel
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Executive Added Successfully!"
        updatemessage="Executive Updated Successfully!"
        state={state?.id}
        navigateUrl="/viewExecutive"
      />
    </>
  );
};

export default NewExecutive;
